export default "__VITE_ASSET__curRJplX__"